export default "__VITE_ASSET__cfec4a18__"